<template lang="pug">

  .button-share(@click="openShare")
    icon-share

</template>

<script>

  import IconShare from 'src/components/vca/widgets/IconShare'
  import {mapMutations} from 'vuex'
  export default {
    name: 'button-share',
    components: {
      IconShare,
    },
    data() {
      return {}
    },
    props: {},
    computed: {},
    mounted() {},
    beforeDestroy() {},
    methods: {
      //...mapMutations('app', ['openMenu'])
      openShare(){

      }
    },
    watch: {},
  }
</script>

<style lang="sass" scoped>
  @import "src/styles/common.sass"

  .button-share
    pointer-events: all
    position: absolute
    bottom: $ui-margin-top + 0.07rem
    right: $ui-margin-left + 0.15rem
    width: 0.3rem


  // img
  //   display: block
  //   +center-img()
  //   max-width: 70%
  //   max-height: 70%

</style>
